<template>
  <div class="coverInfo" :class="{ fullCover: isFullCover }">
    <p class="title">
      {{
        $filters.breakLine(title || (hasAward ? $t("titleAward") : $t("title")))
      }}
    </p>
    <div class="btnWrap">
      <a
        class="start"
        :class="{ fullCover: isFullCover }"
        href="javascript:void(0)"
        @click="start"
      >
        <span class="text">{{ $t("start") }}</span>
        <span class="icon-arrow"></span>
      </a>
      <p class="tips">
        {{ $filters.breakLine(description) }}
      </p>
    </div>
  </div>
</template>
<script lang="ts" setup>
import surveyHook from "@/hooks/surveyHook";
const { start, title, description, hasAward, isFullCover, coverFontColor } =
  surveyHook();
</script>
<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";

.coverInfo {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  z-index: 1;
  &.fullCover {
    .title,
    .tips {
      color: v-bind(coverFontColor);
      text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    }
  }
  @media screen and (orientation: portrait) {
    justify-content: flex-end;
    margin-top: 20px;
  }
}
.btnWrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.title {
  font-size: 70px;
  color: $themeFontColor;
  margin-bottom: 70px;
  text-align: center;
  word-break: break-word;
  white-space: pre-wrap;
  padding: 0 20px;

  &.big {
    font-size: 55px;
    text-align: center;
  }
}
.start {
  display: flex;
  color: #fff;
  width: 600px;
  font-size: 30px;
  height: 100px;
  margin: 0 0 20px;
  align-items: center;
  justify-content: center;
  background: $btnColor;
  border-radius: 10px;
  transition: filter 0.4s;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  &.fullCover {
    @include setBackground(596px, 100px, "start_bg.png");
    background-size: 100% 100% !important;
  }
  &:hover {
    filter: brightness(1.1);
  }
}
.icon-arrow {
  display: inline-block;
  margin-left: 20px;
  @include setBackground(20px, 20px, "arrow_right.png");
}
.tips {
  font-size: 18px;
  color: #888;
  text-align: center;
  line-height: 1.3;
  width: 600px;
  word-break: break-word;
}
</style>
